import { z } from 'zod';

export const newsItemSchema = z.object({
  title: z.string(),
  summary: z.string().nullable().optional(),
  url: z.string().url(),
  image: z.string().url().nullable().optional(),
  author: z.string().nullable().optional(),
  publish_date: z.string().nullable().optional(),
});

export const newsResponseSchema = z.object({
  news: z.array(newsItemSchema),
});

export type NewsItem = z.infer<typeof newsItemSchema>;
export type NewsResponse = z.infer<typeof newsResponseSchema>;
